import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "avatar-selector-horizontal"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "center"
  }
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "center",
    "margin-top": "1.0rem"
  }
};
const _hoisted_4 = {
  key: 0,
  class: "avatar-container"
};
const _hoisted_5 = ["onClick"];
import { ElButton, ElImage } from 'element-plus';
import { onMounted, ref, watch } from 'vue';
import { calculateMD5, compressImage } from '@/tools/utils';
import { request } from '@/manager/net_manager';
export default {
  __name: 'AvatarSelector-Horizontal',
  props: {
    avatar: {
      type: String,
      default: '',
      required: false
    }
  },
  emits: ['selectedAvatar'],

  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const uploadAvatar = async () => {
      const formData = new FormData();
      formData.append('file', file.value);
      formData.set('name', file.value.name);
      formData.set('path', 'role_avatar');
      formData.set('md5', md5Value.value);
      const headers = {
        'Content-Type': 'multipart/form-data'
      };
      const response = await request('basic/upload_file/', formData, 'UPLOAD', headers); // console.log(`uploadAvatar ${JSON.stringify(response)}`)

      if (response.code === 0) {
        return response.data['file_id'].toString();
      }

      return null;
    };

    __expose({
      uploadAvatar
    });

    const emits = __emit;
    const defaultOptions = ref([]);
    const avatarInput = ref(null);
    const defaultSelect = ref(false);
    const file = ref(null);
    const md5Value = ref(null);
    const selectedAvatar = ref(null);
    onMounted(() => {
      const length = 16;
      defaultOptions.value = Array.from({
        length
      }, (_, index) => ({
        'image': ref(require(`@/assets/defaultAvatar/defaultAvatar${index.toString().padStart(2, '0')}.png`)),
        'value': `defaultAvatar${index.toString().padStart(2, '0')}.png`
      }));
    });

    const openDefaultOptions = () => {
      defaultSelect.value = true;
    };

    const selectedDefaultAvatar = index => {
      defaultSelect.value = false;
      selectedAvatar.value = defaultOptions.value[index]['image'];
      file.value = null;
      md5Value.value = null;
      avatarInput.value.value = null;
    };

    const handleInputChange = event => {
      file.value = event.target.files[0];

      if (file.value) {
        compressImage(file.value, 1024 * 1024, value => {
          file.value = value;
          selectedAvatar.value = URL.createObjectURL(file.value);
          calculateMD5(file.value, value => {
            // console.log(`md5 = ${value}`)
            md5Value.value = value; // uploadAvatar()
          });
        });
      }
    };

    onMounted(() => {
      if (defaultOptions.value.length > 0) {
        selectedDefaultAvatar(0);
      }
    });
    watch(selectedAvatar, () => {
      let buffer = defaultOptions.value.filter(item => item.image === selectedAvatar.value);

      if (buffer.length === 0) {
        emits('selectedAvatar', selectedAvatar.value);
      } else {
        emits('selectedAvatar', buffer[0].value);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_col, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
          class: _normalizeClass(["selected-avatar", defaultSelect.value ? 'alpha-avatar' : selectedAvatar.value ? 'empty-avatar' : ''])
        }, [_createVNode(_unref(ElImage), {
          src: selectedAvatar.value ?? __props.avatar,
          fit: "cover",
          draggable: "false"
        }, null, 8, ["src"])], 2)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("input", {
          type: "file",
          accept: "image/png, image/jpeg",
          style: {
            "display": "none"
          },
          ref_key: "avatarInput",
          ref: avatarInput,
          onChange: handleInputChange
        }, null, 544), _createVNode(_unref(ElButton), {
          onClick: openDefaultOptions
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" 选择一个默认头像 ", -1)]))]),
          _: 1
        }), _createVNode(_unref(ElButton), {
          onClick: _cache[0] || (_cache[0] = () => {
            defaultSelect.value = false;
            avatarInput.value.click();
          })
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" 上传头像 ", -1)]))]),
          _: 1
        })])]),
        _: 1
      }), defaultSelect.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(defaultOptions.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "avatar-item",
          key: index,
          onClick: $event => selectedDefaultAvatar(index)
        }, [_createVNode(_unref(ElImage), {
          src: item['image'],
          shape: "circle",
          draggable: false
        }, null, 8, ["src"])], 8, _hoisted_5);
      }), 128))])) : _createCommentVNode("", true)]);
    };
  }

};